import React from 'react'
import { FormattedMessage } from 'react-intl'

import { HouseCorporateEveningGlobalFieldProps } from '../../form-container/HouseCorporateEveningGlobalFormContainer'
import { ControlledHourPicker } from '../../../../../../../../forms/hour-picker/ControlledHourPicker'

export const HouseCorporateEveningGlobalHoursFields = ({
  control,
  isFieldDisabled,
}: Omit<HouseCorporateEveningGlobalFieldProps, 'currencyArea'>) => {
  const fieldProps = {
    disabled: isFieldDisabled,
    control,
    type: 'text',
    inline: true,
    rules: { required: 'Champ requis.' },
  }
  return (
    <>
      <ControlledHourPicker
        {...fieldProps}
        label={
          <FormattedMessage
            id='ui.HouseCorporateEveningEventFormFields.options.startHour'
            defaultMessage='Heure de <bold>début</bold> de privatisation'
            values={{ bold: (content) => <b>{content}</b> }}
          />
        }
        name='options.hours.startAt'
        placeholder='18:00'
      />

      <ControlledHourPicker
        {...fieldProps}
        label={
          <FormattedMessage
            id='ui.HouseCorporateEveningEventFormFields.options.endHour'
            defaultMessage='Heure de <bold>fin</bold> de privatisation'
            values={{ bold: (content) => <b>{content}</b> }}
          />
        }
        name='options.hours.endAt'
        placeholder='00:00'
      />

      <ControlledHourPicker
        {...fieldProps}
        label={
          <FormattedMessage
            id='ui.HouseCorporateEveningEventFormFields.options.overStayLimitHour'
            defaultMessage="Heure de <bold>privatisation supplémentaire</bold> possible <bold>jusqu'à</bold>"
            values={{ bold: (content) => <b>{content}</b> }}
          />
        }
        name='options.hours.overStayMaxAt'
        placeholder='05:00'
      />
    </>
  )
}
